import { SagaIterator } from 'redux-saga';
import { PARTNER_DASHBOARD_FETCH } from 'src/modules/partner-dashboard/actions/PartnerDashboardActions';
import { loadPartnerDashboard } from 'src/modules/partner-dashboard/sagas/utils/loadPartnerDashboard';
import { logDebug, logError } from 'src/sagas/utils/logging';
import { call, put } from 'typed-redux-saga';

export function* fetchPartnerDashboard(): SagaIterator<void> {
  try {
    yield* call(logDebug, 'Fetching partner dashboard data...');

    const data = yield* call(loadPartnerDashboard);
    yield* put(PARTNER_DASHBOARD_FETCH.trigger(data));

    yield* call(logDebug, 'Fetching partner dashboard data... done', data);
  } catch (error) {
    yield* call(logError, 'Fetching partner dashboard data... error', error);
    throw error;
  }
}
